import React from 'react'

function ViewsIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M14.666 10.6667C14.2978 10.6667 14.0032 10.3671 13.9628 10.0011C13.6317 7.00063 11.0881 4.66671 7.99932 4.66671C4.91058 4.66671 2.36696 7.00063 2.03582 10.0011C1.99543 10.3671 1.70084 10.6667 1.33265 10.6667C0.964462 10.6667 0.662815 10.3672 0.695836 10.0005C1.03242 6.26263 4.17379 3.33337 7.99932 3.33337C11.8249 3.33337 14.9662 6.26263 15.3028 10.0005C15.3358 10.3672 15.0342 10.6667 14.666 10.6667ZM9.99943 9.33339C9.99943 10.438 9.104 11.3334 7.99943 11.3334C6.89486 11.3334 5.99943 10.438 5.99943 9.33339C5.99943 8.22882 6.89486 7.33339 7.99943 7.33339C9.104 7.33339 9.99943 8.22882 9.99943 9.33339ZM11.3328 9.33339C11.3328 11.1743 9.84038 12.6667 7.99943 12.6667C6.15848 12.6667 4.6661 11.1743 4.6661 9.33339C4.6661 7.49244 6.15848 6.00006 7.99943 6.00006C9.84038 6.00006 11.3328 7.49244 11.3328 9.33339Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default ViewsIcon
